import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40490781"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "switch",
    for: 'toggleSwitch' + _ctx.id
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      tabindex: "-1",
      id: 'toggleSwitch' + _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event))
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.localValue]
    ]),
    _hoisted_3,
    (_ctx.localValue && _ctx.activeText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "fev_text5 fw_700 text active",
          innerHTML: _ctx.activeText
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.localValue && _ctx.inactiveText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "fev_text5 fw_700 text inactive",
          innerHTML: _ctx.inactiveText
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}